import { render } from "./ChangeBranchView.vue?vue&type=template&id=03df3284"
import script from "./ChangeBranchView.vue?vue&type=script&lang=js"
export * from "./ChangeBranchView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__